const NotFound = () => {
  return (
    <div className="notFound">
      <h2>404 Error - This page does not exist.</h2>
    </div>
  );
};

export default NotFound;
